import AppInputText from "../../../components/AppInputText/AppInputText";
import CustomColumn from "../../../components/Column";
import CustomRow from "../../../components/Row";
import { useAuth } from "../../../context/AuthContext";
import useForm from "../../../hooks/useForm";
import * as Yup from "yup";
import ArrowLeftOutlined from "@ant-design/icons/lib/icons/ArrowLeftOutlined";
import { Card, Col, Row } from "antd";

interface Props {
  setActiveMenuNav: (val: number) => void;
}

function UserProfile(props: Props) {
  const { setActiveMenuNav } = props;
  const { authData } = useAuth();

  const formik = useForm<{ full_name: string; password: string; address: string }>({
    initialValues: {
      password: "",
      full_name: authData?.display_name ?? "",
      address: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Mật khẩu không được để trống"),
    }),
    onSubmit(values, formikHelpers) {},
  });

  return (
    <CustomColumn
      className="w-100 gap-4"
      style={{
        padding: "24px 80px",
        boxSizing: "border-box",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <CustomColumn className="gap-3">
        <CustomRow>
          <div
            onClick={() => setActiveMenuNav(1)}
            style={{
              cursor: "pointer",
              color: "#1677ff",
              marginBottom: 16,
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <ArrowLeftOutlined />
            Quay lại trang chủ
          </div>
        </CustomRow>
        <h3>👤 Thông tin cá nhân</h3>
        <AppInputText
          orientation="col"
          isRequired
          label="Họ và Tên"
          currentValue={formik.values.full_name}
          onTextChange={(value) => {
            formik.updateFieldValue("full_name", value);
          }}
          additionProps={{
            className: "w-100 form-item",
            autoFocus: true,
          }}
        />
        <AppInputText
          orientation="col"
          isRequired
          label="Số điện thoại"
          currentValue={authData?.user_name}
          additionProps={{
            className: "w-100 form-item",
            disabled: true,
          }}
        />
        <AppInputText
          orientation="col"
          label="Địa chỉ"
          additionProps={{ className: "w-100 form-item" }}
          textType="MULTI_LINE"
        />
      </CustomColumn>
      {/* ===== Thông tin thành viên ===== */}
      <Card title="⭐ Thông tin thành viên" bordered={false} style={{ borderRadius: 12 }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <strong>Số đơn hàng</strong>
            <div style={{ fontSize: 18, color: "#1677ff" }}>
              {authData?.total_orders?.toLocaleString() || 0} đơn
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <strong>Đã chi tiêu</strong>
            <div style={{ fontSize: 18, color: "#d48806" }}>
              {authData?.total_spent?.toLocaleString() || 0} đ
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <strong>Tích điểm</strong>
            <div style={{ fontSize: 18, color: "#faad14" }}>0 điểm</div>
          </Col>

          <Col xs={24} sm={12}>
            <strong>Hạng hội viên</strong>
            <div style={{ fontSize: 18, color: "#1677ff" }}>Standard</div>
          </Col>
        </Row>

        <div style={{ marginTop: 16, fontSize: 13 }}>
          🎁 <b>Giảm 20% tổng hóa đơn</b> cho đơn hàng mua lần thứ 2 - tối đa 50K ({" "}
          <b>Chỉ áp dụng khi đơn hàng được đặt trực tiếp trên website của chúng tôi</b>)
        </div>
        <div style={{ fontSize: 13 }}>
          🎁 <b>Giảm 2% tổng hóa đơn</b> cho đơn hàng mua lần thứ 3 trở đi ({" "}
          <b>Chỉ áp dụng khi đơn hàng được đặt trực tiếp trên website của chúng tôi</b>)
        </div>
      </Card>
    </CustomColumn>
  );
}
export default UserProfile;
